// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__7sOe0","error":"InputSecondary_error__RUBd_","disabled":"InputSecondary_disabled__2W7IP"};